module.exports = __webpack_public_path__ + "img/collection-card cover.7762631d.jpg";